<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-3">
    <div class="col-sm-12">
      <button type="button" class="btn btn-add" @click="opentNewTab()">
          {{$t('OPENFOURSIGHTINNEWTAB')}}
        </button>
    </div>
  </div>
  <template v-for="item in formData.root">
    <div class="form-row mb-3">
      <div class="col-sm-12 mb-1" v-html="item.question"></div>
      <div class="col-sm-12" v-if="item.answerType == 'free'">
        <b-form-input type="text" v-model="item.answer"></b-form-input>
      </div>
      <div class="col-sm-12" v-else-if="item.answerType == 'multy'">
        <b-form-select :options="item.multyAnswers" v-model="item.answer" value-field="answer" text-field="answer"></b-form-select>
      </div>
      <div class="col-sm-12" v-else>
        <b-form-textarea type="text" v-model="item.answer"></b-form-textarea>
      </div>
    </div>
  </template>
</div>
</template>

<script>
export default
{
  name: 'FormPreview',
  props: ['formData'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {
    opentNewTab()
    {
      var me = this;
      window.open('/admin/#/dashboard');
    }
  },
  computed:
  {

  }
}
</script>